module.exports = __webpack_public_path__ + "public/img/kanjia.f43d5085.png";